package com.sddamico.swigmore.ds.poll

import androidx.compose.runtime.Composable
import com.sddamico.swigmore.ds.SwColor
import com.sddamico.swigmore.ds.css
import com.sddamico.swigmore.ds.typeBody
import com.sddamico.swigmore.ds.typeDisplay
import com.sddamico.swigmore.ds.typeMono
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

/**
 * A team on an owner's previous ballot and how it did that week: "Beat Fink" with the score kept on
 * one line, and a W/L/T mark that turns gold on a win. [outcome] is null until the game is scored.
 */
@Composable
fun PreviousPickRow(position: Int, team: String, result: String, score: String?, outcome: String?, won: Boolean) {
  Div(
    attrs = Modifier.css("display" to "grid", "grid-template-columns" to "28px minmax(0,1fr) auto", "gap" to "10px",
      "align-items" to "center", "padding" to "6px 4px", "border-top" to "1px solid ${SwColor.hairlineSoft}").toAttrs()
  ) {
    Span(attrs = Modifier.typeDisplay("16px").toAttrs()) { Text(position.toString()) }
    Div {
      Div(attrs = Modifier.typeBody("14px", 600, "normal").toAttrs()) { Text(team) }
      Div(attrs = Modifier.typeMono("11px").css("color" to SwColor.textMuted).toAttrs()) {
        Text(result)
        if (score != null) {
          Text(" ")
          Span(attrs = Modifier.css("white-space" to "nowrap").toAttrs()) { Text(score) }
        }
      }
    }
    if (outcome != null) {
      Span(attrs = Modifier.typeDisplay("16px").css("color" to if (won) SwColor.gold else SwColor.textMuted).toAttrs()) {
        Text(outcome)
      }
    }
  }
}
